import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Player.scss';

const Player = React.forwardRef((props, ref) => {
  const { children, className, style, toolbar, ...nativeProps } = props;

  const playerProps = {
    style: {
      // Relative positioning is needed to make absolutely positioned elements within the player
      // position themselves relative to the player wrapper (and not the consuming component)
      position: 'relative',
      width: '100%',
      height: '100%',
      ...style
    },
    ...nativeProps
  };

  const classes = classNames({
    'up-seismic-player': true,
    [`${className}`]: !!className
  });

  return (
    <div
      className={classes}
      datatest="seismic-player-container"
      aria-label={props['aria-label']}
      role={props.role}
      {...playerProps}
      ref={ref}
    >
      {children}
      {toolbar}
    </div>
  );
});

Player.propTypes = {
  toolbar: PropTypes.node
};

export default Player;
